import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck, faInfoCircle, faCheckCircle, faBug, faUserTimes, faUserShield } from '@fortawesome/free-solid-svg-icons';


type ModalContentProps = {
    title: any,
    text?: any,
    testid?: string,
    showLogoutButton?: boolean,
}

export const CONTENT_VEHICLE_BLOCKED_INFO_MODAL = {
    title: (
        <React.Fragment>
            <FontAwesomeIcon icon={faInfoCircle} />
            <FormattedMessage id="INFO_MODAL_VEHICLE_BLOCKED_TITLE" />
        </React.Fragment>
    ),
    text: <FormattedMessage id="INFO_MODAL_VEHICLE_BLOCKED_TEXT" />,
};

export const CONTENT_CONNECTION_REQUESTED_MODAL = {
    title: (
        <React.Fragment>
            <FontAwesomeIcon icon={faCheckCircle} />
            <FormattedMessage id="CONNECTION_REQUESTED_MODAL_TITLE" />
        </React.Fragment>
    ),
    text: <FormattedMessage id="CONNECTION_REQUESTED_MODAL_TEXT" />,
};

export const CONTENT_SEND_FEEDBACK_TO_SUPPORT_SUCCESS_MODAL = {
    title: (
        <React.Fragment>
            <FontAwesomeIcon icon={faClipboardCheck} />
            <FormattedMessage id="FEEDBACK_THANK_YOU_TITLE" />
        </React.Fragment>
    ),
    text: <FormattedMessage id="FEEDBACK_THANK_YOU_TEXT" />,
};

export const CONTENT_SEND_MESSAGE_TO_SUPPORT_SUCCESS_MODAL = {
    title: (
        <React.Fragment>
            <FontAwesomeIcon icon={faClipboardCheck} />
            <FormattedMessage id="SEND_MESSAGE_TO_SUPPORT_SUCCESS_MODAL_TITLE" />
        </React.Fragment>
    ),
    text: <FormattedMessage id="SEND_MESSAGE_TO_SUPPORT_SUCCESS_MODAL_TEXT" />,
};

export const CONTENT_REPORT_A_BUG_TO_SUPPORT_MODAL = {
    title: (
        <React.Fragment>
            <FontAwesomeIcon icon={faBug} />
            <FormattedMessage id="REPORT_A_BUG" />
        </React.Fragment>
    ),
    textareaPlaceholderId: 'PLACEHOLDER_REPORT_A_BUG_INSTRUCTIONS',
};

export const getModalContentAuthorizationForbidden = (email: string): ModalContentProps => {
    return {
        title: (
            <React.Fragment>
                <FontAwesomeIcon icon={faUserShield} />
                <FormattedMessage id="MODAL_403_FORBIDDEN_TITLE" />
            </React.Fragment>
        ),
        text: <FormattedMessage id="MODAL_403_FORBIDDEN_TEXT" values={{ email: email }} />,
        showLogoutButton: true
    }
};

export const unclaimFailedModal = (message: string, testId: string): ModalContentProps => {
    return {
        title: (
            <React.Fragment>
                <FontAwesomeIcon icon={faUserTimes} />
                <FormattedMessage id="MODAL_TITLE_UNCLAIM_FAILED" />
            </React.Fragment>
        ),
        text: message,
        testid: testId,
    };
};
